<template>
    <form ref="form" :action="data.url" method="POST">
        <input
            v-for="postParam in data.postParams"
            :key="postParam.name"
            type="hidden"
            :name="postParam.name"
            :value="postParam.value"
        />
        <input type="hidden" name="paymentNumber" :value="data.paymentNumber" />
        <input type="hidden" name="paymentTransactionId" :value="data.paymentTransactionId" />
    </form>
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'
    import {readBody} from 'h3'

    // TODO [P1] Need check
    @Component({
        async setup() {
            const {data} = await useAsyncData(`payment-redirect-${Date.now()}`, async () => {
                if (import.meta.server) {
                    const post = await readBody(useRequestEvent())
                    post.url = post.originUrl
                    delete post.originUrl

                    const data = {
                        postParams: [],
                    }
                    Object.keys(post).forEach(key => {
                        const val = post[key]
                        if (!['paymentNumber', 'paymentTransactionId', 'url'].includes(key)) {
                            if (Array.isArray(val)) {
                                data.postParams.push({
                                    name: `${key}[0]`,
                                    value: val[0],
                                })
                            } else {
                                data.postParams.push({
                                    name: key,
                                    value: val,
                                })
                            }
                        } else {
                            data[key] = key === 'paymentTransactionId' ? parseInt(val, 10) : val
                        }
                    })
                    return data
                }
            })
            return {data: data.value}
        },
    })
    export class PaymentRedirectPage extends Vue {
        //TODO Need refactoring with PaymentRedirectForm

        data = {
            postParams: [],
        }

        mounted() {
            this.$refs.form.submit()
        }
    }

    export default PaymentRedirectPage
</script>
